/* Tocha store locator.
   Data is server-rendered by sections/store-locator.liquid into a JSON script
   tag, so the list exists before this file runs and crawlers see every stockist.
   This layer adds the map, clustering, geocoded search, and list filtering. */
(function () {
  'use strict';

  var CHAR = '#1A130C';
  var MUSTARD = '#F9AD15';
  var BONE = '#FBF8F2';
  var MAX_LIST = 120; // cap DOM writes; count label always reports the true total
  var HOME = { lat: 56.13, lng: -106.35 };
  var HOME_ZOOM = 4;

  /* Much of the metaobject data was entered in caps ("1900 WEST 1ST AVENUE").
     Normalise for display only -- the stored values are untouched. Strings that
     are already mixed case were entered deliberately, so they pass through as-is. */
  function titleCase(s) {
    if (!s) return s;
    if (s !== s.toUpperCase()) return s;
    var out = s.toLowerCase().replace(/\b([a-z])([a-z']*)/g, function (m, a, b) {
      return a.toUpperCase() + b;
    });
    // Unit letters attached to a number stay capital: 240A, 12B. Two-letter
    // ordinals (1st, 8th) never match this because of the word boundary.
    out = out.replace(/(\d)([a-z])\b/g, function (m, d, l) { return d + l.toUpperCase(); });
    out = out.replace(/\b(\d+)(St|Nd|Rd|Th)\b/g, function (m, n, sfx) { return n + sfx.toLowerCase(); });
    out = out.replace(/\b(Nw|Ne|Sw|Se)\b/g, function (m) { return m.toUpperCase(); });
    return out;
  }

  /* Google-style teardrop, drawn in brand colours: mustard body, char keyline,
     char dot for the head. An SVG data URL so pins and cluster bubbles share
     one visual language. */
  function pinIcon(scale) {
    var w = Math.round(28 * scale), h = Math.round(40 * scale);
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h +
      '" viewBox="0 0 28 40">' +
      '<path d="M14 38.5C14 38.5 25.5 23.8 25.5 14A11.5 11.5 0 1 0 2.5 14C2.5 23.8 14 38.5 14 38.5Z" ' +
      'fill="' + MUSTARD + '" stroke="' + CHAR + '" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<circle cx="14" cy="14" r="4.5" fill="' + CHAR + '"/></svg>';
    return {
      url: 'data:image/svg+xml;base64,' + btoa(svg),
      scaledSize: new google.maps.Size(w, h),
      anchor: new google.maps.Point(w / 2, h)
    };
  }

  function boot(root) {
    var dataEl = root.querySelector('[data-locator-data]');
    if (!dataEl) return;

    var all;
    try { all = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }

    var mappable = all.filter(function (s) {
      return typeof s.lat === 'number' && typeof s.lng === 'number' &&
             !isNaN(s.lat) && !isNaN(s.lng);
    });

    var mapEl = root.querySelector('[data-locator-map]');
    var listEl = root.querySelector('[data-locator-list]');
    var countEl = root.querySelector('[data-locator-count]');
    var searchEl = root.querySelector('[data-locator-search]');
    var formEl = root.querySelector('[data-locator-form]');
    var provinceEl = root.querySelector('[data-locator-province]');
    var emptyEl = root.querySelector('[data-locator-empty]');
    var statusEl = root.querySelector('[data-locator-status]');

    /* Two different jobs share one input.

       placeMode = the term resolved to a location (postal code, city), so the
       map has moved there and the list should show what is nearby. Matching
       the term against stockist text would empty the list -- no store record
       contains the string "v6a 4k4" -- which is exactly the bug this flag
       fixes: a map full of pins beside "0 stockists found".

       text mode = the term is a store or city name typed to filter the list,
       matched against every record regardless of what is on screen. */
    var placeMode = false;

    var map = new google.maps.Map(mapEl, {
      center: HOME,
      zoom: HOME_ZOOM,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      clickableIcons: false,
      backgroundColor: BONE,
      styles: [
        { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
        { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }
      ]
    });

    var info = new google.maps.InfoWindow();
    var geocoder = new google.maps.Geocoder();
    var basePin = pinIcon(1);
    var activePin = pinIcon(1.25);
    var activeMarker = null;

    var markers = mappable.map(function (s) {
      var m = new google.maps.Marker({
        position: { lat: s.lat, lng: s.lng },
        title: titleCase(s.name),
        icon: basePin
      });
      m.__store = s;
      m.addListener('click', function () { select(m); });
      return m;
    });

    function select(m) {
      if (activeMarker && activeMarker !== m) activeMarker.setIcon(basePin);
      activeMarker = m;
      m.setIcon(activePin);
      info.setContent(popupHtml(m.__store));
      info.open({ anchor: m, map: map });
    }

    info.addListener('closeclick', function () {
      if (activeMarker) activeMarker.setIcon(basePin);
      activeMarker = null;
    });

    var byId = {};
    markers.forEach(function (m) { byId[m.__store.id] = m; });

    var clusterer = new markerClusterer.MarkerClusterer({
      map: map,
      markers: markers,
      renderer: {
        render: function (cluster) {
          var count = cluster.count;
          var r = count < 10 ? 18 : count < 50 ? 22 : 26;
          var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + (r * 2) +
            '" height="' + (r * 2) + '" viewBox="0 0 ' + (r * 2) + ' ' + (r * 2) + '">' +
            '<circle cx="' + r + '" cy="' + r + '" r="' + (r - 1) + '" fill="' + MUSTARD +
            '" stroke="' + CHAR + '" stroke-width="1.5"/></svg>';
          return new google.maps.Marker({
            position: cluster.position,
            icon: {
              url: 'data:image/svg+xml;base64,' + btoa(svg),
              scaledSize: new google.maps.Size(r * 2, r * 2),
              anchor: new google.maps.Point(r, r)
            },
            label: { text: String(count), color: CHAR, fontSize: '12px', fontWeight: '700' },
            zIndex: 1000 + count
          });
        }
      }
    });

    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function addressLine(s) {
      var bits = [s.address, s.city, s.province, s.postal_code].filter(function (b) {
        return b && String(b).trim() && String(b).trim().toUpperCase() !== 'N/A';
      });
      return bits.map(function (b, i) {
        // Postal codes keep their capitals; everything else is title-cased.
        return i === bits.length - 1 && /\d/.test(b) && b.length <= 8 ? b : titleCase(b);
      }).join(', ');
    }

    function popupHtml(s) {
      var addr = addressLine(s);
      var q = encodeURIComponent(s.name + ' ' + addr);
      return '<div class="locator-popup">' +
        '<p class="locator-popup__name">' + esc(titleCase(s.name)) + '</p>' +
        (addr ? '<p class="locator-popup__addr">' + esc(addr) + '</p>' : '') +
        '<a class="locator-popup__link" target="_blank" rel="noopener" href="https://www.google.com/maps/search/?api=1&query=' + q + '">Directions &rarr;</a>' +
        '</div>';
    }

    function distance(a, b) {
      var dx = a.lat - b.lat, dy = a.lng - b.lng;
      return dx * dx + dy * dy; // squared euclidean: ordering only, no sqrt needed
    }

    function textMatch(s, term) {
      if (!term) return true;
      var hay = (s.name + ' ' + (s.city || '') + ' ' + (s.province || '') + ' ' +
                 (s.address || '') + ' ' + (s.postal_code || '')).toLowerCase();
      return hay.indexOf(term) !== -1;
    }

    function setStatus(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.hidden = !msg;
    }

    /* Move the map to a typed place. Without this the search could only ever
       match text already in the data, so a postal code with no exact match
       returned nothing and the map never moved. Restricted to Canada so short
       terms like "Victoria" resolve locally rather than to Australia. */
    function goToPlace(term) {
      if (!term) return;
      setStatus('Searching…');
      geocoder.geocode(
        { address: term, componentRestrictions: { country: 'CA' } },
        function (results, status) {
          if (status === 'OK' && results && results[0]) {
            placeMode = true;
            var g = results[0].geometry;
            if (g.viewport) map.fitBounds(g.viewport);
            else map.setCenter(g.location);
            // A postal code viewport can be tiny; keep enough context to show
            // nearby stockists rather than an empty street.
            google.maps.event.addListenerOnce(map, 'idle', function () {
              if (map.getZoom() > 13) map.setZoom(13);
              render();
            });
            setStatus('Showing stockists near ' + results[0].formatted_address);
          } else if (status === 'ZERO_RESULTS') {
            setStatus('No place found for that search.');
          } else {
            setStatus('Search is unavailable right now.');
          }
        }
      );
    }

    function render() {
      var raw = (searchEl && searchEl.value || '').trim();
      var term = placeMode ? '' : raw.toLowerCase();
      var prov = provinceEl && provinceEl.value || '';
      var bounds = map.getBounds();
      // A text search looks across every stockist, so a match that sits off the
      // current viewport still appears. A place search has already moved the
      // map, so the viewport is the answer.
      var useBounds = !term;

      var rows = mappable.filter(function (s) {
        if (prov && s.province !== prov) return false;
        if (!textMatch(s, term)) return false;
        if (useBounds && bounds && !bounds.contains({ lat: s.lat, lng: s.lng })) return false;
        return true;
      });

      var c = map.getCenter();
      if (c) {
        var centre = { lat: c.lat(), lng: c.lng() };
        rows.sort(function (a, b) { return distance(a, centre) - distance(b, centre); });
      }

      if (countEl) {
        var noun = rows.length === 1 ? 'stockist' : 'stockists';
        countEl.textContent = term
          ? rows.length + ' ' + noun + ' found'
          : rows.length + ' ' + noun + ' in view';
      }
      if (emptyEl) {
        emptyEl.textContent = term
          ? 'No stockists match that search.'
          : 'No stockists in this area. Zoom out or move the map.';
        emptyEl.hidden = rows.length !== 0;
      }

      var html = rows.slice(0, MAX_LIST).map(function (s) {
        var addr = addressLine(s);
        return '<li class="locator-item">' +
          '<button type="button" class="locator-item__btn" data-locator-goto="' + esc(s.id) + '">' +
          '<span class="locator-item__name">' + esc(titleCase(s.name)) + '</span>' +
          (addr ? '<span class="locator-item__addr">' + esc(addr) + '</span>' : '') +
          '</button></li>';
      }).join('');

      if (rows.length > MAX_LIST) {
        html += '<li class="locator-item locator-item--more">Showing the ' + MAX_LIST +
          ' closest of ' + rows.length + '. Zoom in to narrow the list.</li>';
      }
      listEl.innerHTML = html;
    }

    listEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-locator-goto]');
      if (!btn) return;
      var m = byId[btn.getAttribute('data-locator-goto')];
      if (!m) return;
      map.panTo(m.getPosition());
      if (map.getZoom() < 13) map.setZoom(13);
      select(m);
    });

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        goToPlace((searchEl && searchEl.value || '').trim());
      });
    }

    var idleTimer;
    map.addListener('idle', function () {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(render, 60);
    });

    if (searchEl) {
      // Editing the term makes it a text search again until the next submit.
      searchEl.addEventListener('input', function () {
        placeMode = false;
        setStatus('');
        clearTimeout(idleTimer);
        idleTimer = setTimeout(render, 150);
      });
    }
    if (provinceEl) provinceEl.addEventListener('change', render);

    var resetEl = root.querySelector('[data-locator-reset]');
    if (resetEl) {
      resetEl.addEventListener('click', function () {
        if (searchEl) searchEl.value = '';
        if (provinceEl) provinceEl.value = '';
        placeMode = false;
        setStatus('');
        map.setCenter(HOME);
        map.setZoom(HOME_ZOOM);
        render();
      });
    }

    // Geolocation is opt-in via the button only; never prompt on load.
    var nearEl = root.querySelector('[data-locator-near]');
    if (nearEl && navigator.geolocation) {
      nearEl.hidden = false;
      nearEl.addEventListener('click', function () {
        setStatus('Finding your location…');
        navigator.geolocation.getCurrentPosition(function (pos) {
          if (searchEl) searchEl.value = '';
          placeMode = false;
          setStatus('');
          map.setCenter({ lat: pos.coords.latitude, lng: pos.coords.longitude });
          map.setZoom(11);
        }, function () {
          setStatus('Could not get your location.');
        });
      });
    }
  }

  window.tochaStoreLocatorInit = function () {
    document.querySelectorAll('[data-locator-root]').forEach(boot);
  };
})();
